import { render, staticRenderFns } from "./PagePaymentResult.vue?vue&type=template&id=45fa6e60&scoped=true"
import script from "./PagePaymentResult.vue?vue&type=script&lang=ts"
export * from "./PagePaymentResult.vue?vue&type=script&lang=ts"
import style0 from "./PagePaymentResult.vue?vue&type=style&index=0&id=45fa6e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa6e60",
  null
  
)

export default component.exports